<template>
  <div>
    <p v-if="!sortedTasks" v-t="'task.list.is-loading'" />
    <p
      v-else-if="!sortedTasks.length"
      v-t="'task.list.is-empty.' + (showFinishDate ? 'finished' : 'open')"
    />
    <table v-else class="table is-fullwidth">
      <thead>
        <tr>
          <th>
            {{ $t("task.date") | titlecase }}
          </th>
          <th v-if="showCustomer">
            {{ $t("task.customer") | titlecase }}
          </th>
          <th>
            {{ $t("task.doc1") | titlecase }}
          </th>
          <th>
            {{ $t("task.doc2") | titlecase }}
          </th>
          <th>
            {{ $t("task.doc3") | titlecase }}
          </th>
          <th v-if="showState">
            {{ $t("task.state") | titlecase }}
          </th>
          <th v-if="showAction" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="task of sortedTasks" :key="task.taskId + (task.state || 0)">
          <td>{{ task.date.toLocaleString() }}</td>
          <td v-if="showCustomer">{{ task.customerName }}</td>
          <td class="is-breakable">{{ task.file1Name }}</td>
          <td class="is-breakable">{{ task.file2Name }}</td>
          <td class="is-breakable">{{ task.file3Name }}</td>
          <td v-if="showState">
            {{ stateLabel(task.state) }}
          </td>
          <td v-if="showAction">
            <r-button
              v-t="'task.button.edit'"
              size="small"
              @click="$router.push(actionTarget(task.state, task.taskId))"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TaskList",
  props: {
    tasks: {
      type: Array,
      default: null
    },
    showCustomer: {
      type: Boolean,
      default: false
    },
    showState: {
      type: Boolean,
      default: false
    },
    showAction: {
      type: Boolean,
      default: false
    },
    showFinishDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortedTasks() {
      return (
        this.tasks &&
        this.tasks
          .slice()
          /** Sort by date in reverse order */
          .sort((a, b) =>
            a.date.getTime() < b.date.getTime()
              ? 1
              : a.date.getTime() > b.date.getTime()
              ? -1
              : 0
          )
      );
    }
  },
  methods: {
    stateLabel(state) {
      switch (state) {
        case "NEW":
          return this.$t("task.states.new");
        case "DOWNLOADED":
          return this.$t("task.states.downloaded");
        case "UPLOADED":
          return this.$t("task.states.uploaded");
        case "SEND":
          return this.$t("task.states.send");
        default:
          return this.$t("task.states.default");
      }
    },
    actionTarget(state, taskId) {
      switch (state) {
        case "INIT":
          return "/auftrag-erstellen/" + taskId;
        case "DOWNLOADED":
          return "/auftrag-zuruecksenden";
        case "UPLOADED":
          return "/auftrag-zuruecksenden/" + taskId;
        default:
          return "/auftrag-empfangen";
      }
    }
  }
};
</script>
